import {forkLayout,quarryLayout} from './layouts.js';
import {emptyStory,normalizeStory,hasItem} from './story.js';
export const WORLDS = [
  { name: 'The Old Quarry', short: 'QUARRY', subtitle: 'Someone was here before you.', sky: ['#dce5df','#a2bab7','#526e76'], fog: '#c5d4cc', rock: '#364b53', timber: '#c6b68e', accent: '#e7b66a', bpm: 104, notes: [50,57,62,65,69,62,57,53] },
  { name: 'The Windward Works', short: 'WINDWARD', subtitle: 'The machines are still listening.', sky: ['#b9c8d1','#819dac','#314656'], fog: '#aabdc5', rock: '#293c4c', timber: '#b9c5c7', accent: '#e9b979', bpm: 116, notes: [45,52,57,60,64,57,52,48] },
];
const names = [
  'The first light','Loose footing','An old route','Across the gap','A familiar mark',
  'The long way up','Borrowed balance','Under the cable','No one below','Beyond the quarry',
  'The listening posts','A change in the air','Crosswind','The empty station','Three notes',
  'When the wind turns','The bent mast','The receiver','Above the works','Still somewhere above',
];
const height = [12,14,15,16,17,18,19,20,21,23, 16,17,18,19,20,20,21,22,23,24];
const exitSides = [1,1,-1,1,-1,1,1,-1,-1,1, 1,-1,1,-1,1,1,-1,1,-1,1];
const routePars=[18,19,20,23,23,19,24,25,26,19,11,13,14,18,14,15,15,15,16,18];
export const LEVELS = names.map((name,id) => {
  const side=exitSides[id];
  const terrain=id<10?quarryLayout(id,height[id],side):forkLayout(id,height[id],side);
  return {
  id, name, world: Math.floor(id/10), number: id%10+1, height: height[id],
  altitude: height.slice(0,id).reduce((sum,h)=>sum+h,0),
  exitSide: exitSides[id], exitInset: -.35,
  ...terrain,
  par: routePars[id]||Math.ceil(height[id]/.64*.3+8.5),
  wind: id<2 ? .015 : id<10 ? .1+(id%5)*.045 : .28+(id%5)*.055,
  frequency: 35,
  strength: id<2 ? 420 : id===4 ? 650 : id===5||id===6 ? 600 : id===7 ? 650 : id<10 ? 399 : id===16 ? 360 : 342,
  seed: 3917+id*761,
  clue: ({0:'THE LIGHT IS STILL ON.',4:'THE SAME MARK. AGAIN.',9:'THE ROUTE CONTINUES.',10:'NO TRANSMITTER FOUND.',14:'THREE NOTES. ??? ANSWERS.',18:'THESE WERE RECEIVERS.',19:'??? IS SOMEWHERE ABOVE.'})[id] || '',
};});
export const UNLOCKS = [
  { at: 6, name: 'Field brace', detail: 'Q · Reinforce your most strained connection once per climb.', key: 'brace', itemKey:'field_brace' },
  { at: 32, name: 'Power hammer', detail: 'Build 12% faster. Keep your balance.', key: 'hammer' },
  { at: 45, name: 'Second brace', detail: 'Carry two field braces.', key: 'secondBrace' },
];
export const EMPTY_SAVE = () => ({version:2, levels:{}, story:emptyStory(), audio:true, reducedMotion:false});
export function normalizeSave(value) {
  const out=EMPTY_SAVE();
  if (!value || typeof value!=='object') return out;
  out.audio=value.audio!==false; out.reducedMotion=value.reducedMotion===true;
  out.story=normalizeStory(value.story);
  for (const level of LEVELS) {
    const r=value.levels?.[level.id];
    if (!r || !Array.isArray(r.stars)) continue;
    const stars=[0,1,2].map(i=>r.stars[i]===true);
    // Bonus stars only exist on completed climbs.
    if (!stars[0]) continue;
    out.levels[level.id]={stars,best:Number.isFinite(r.best)&&r.best>0?r.best:null};
  }
  // Existing 0.5 saves that already climbed beyond the first landing keep
  // their route and receive the first story item without losing old stars.
  if(value.version!==2&&LEVELS.slice(1).some(level=>out.levels[level.id]?.stars[0])){
    out.story.rescues['quarry-refuge']=true;
    if(!out.story.inventory.includes('field_brace'))out.story.inventory.push('field_brace');
  }
  return out;
}
export const totalStars = save => Object.values(save.levels).reduce((n,r)=>n+r.stars.filter(Boolean).length,0);
export const toolsFor = (stars,save=null) => ({braces:stars>=45?2:stars>=6||hasItem(save,'field_brace')?1:0,fast:stars>=32});
export const isUnlocked = (save,id) => id===0 || !!save.levels[id-1]?.stars[0]&&(id!==1||save.story?.rescues?.['quarry-refuge']===true);
export function recordWin(save,id,seconds,fragment) {
  const old=save.levels[id]||{stars:[false,false,false],best:null};
  const achieved=[true,seconds<=LEVELS[id].par,!!fragment];
  const record={stars:achieved.map((s,i)=>s||old.stars[i]),best:Math.min(old.best??Infinity,seconds)};
  save.levels[id]=record;
  return {record,achieved,newStars:record.stars.filter(Boolean).length-old.stars.filter(Boolean).length};
}
